import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import DataLoader from "../../../Utils/DataLoader";
import { useSelector } from "react-redux";
import { apiData } from "../../../actions";

export default function HomeWantSeeWorld() {
    const [inclusiveDeals, setInclusiveDeals] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);

    const place = useSelector((state) => state.place);

    const GetInclusiveDeals = async () => {
        try {
            setPageLoading(true);

            let payload = {
                city: place,
                keyword: "Adventure",
                limit: 12,
            };

            let apiRes = await apiData.getRandomDeals(payload);

            if (apiRes?.status >= 200 && apiRes?.status <= 399) {
                setInclusiveDeals(apiRes?.data?.data || []);
            }
        } catch (err) {
            console.log("GetInclusiveDeals Error:", err);
        } finally {
            setPageLoading(false);
        }
    };

    useEffect(() => {
        GetInclusiveDeals();
    }, [place]);

    if (pageLoading) return <DataLoader />;

    return (
        <section className="section-equal-padding the_world_section">
            <div className="container-fluid">
                <div
                    className="section-top-heading mb-3 mb-md-5"
                    uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false"
                >
                    <h2>Want to see the World</h2>
                </div>

                <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={20}
                    // loop={true}
                    // autoplay={{
                    //     delay: 3000,
                    //     disableOnInteraction: false,
                    // }}
                    navigation={true}
                    breakpoints={{
                        0: { slidesPerView: 1 },
                        768: { slidesPerView: 1.5 },
                        991: { slidesPerView: 1.5 },
                        1400: { slidesPerView: 2.5 },
                    }}
                    className="excitement-swiper pb-70"
                    id="WorldOwlItem"
                    uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false"
                >
                    {inclusiveDeals.map((ele, index) => (
                        <SwiperSlide key={index} >
                            <div className="world-tour-figure" >
                                <a href={ele?.link} target="_blank" rel="noreferrer">
                                    <figure>
                                        <img
                                            loading="lazy"
                                            src={ele?.image}
                                            alt={ele?.title || "Destination"}
                                            className="img-fluid"
                                        />
                                    </figure>

                                    <div className="world-tour-link">
                                        <span>
                                            {ele?.title || "Explore"}{" "}
                                            <i className="fa-solid fa-arrow-right"></i>
                                        </span>
                                    </div>
                                </a>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
}
